module.exports = __webpack_public_path__ + "static/media/kjedeleg.3cf253a6.m4a";